import React, { PropTypes } from 'react';

import './styles.scss';
import statsd from '../../../../../lib/StatsD';


export const SettingsButton = props => (
  <div className="settings-button">
    <button
      className={props.className}
      onClick={() => {
        props.onClick();
        statsd.increment(`buttons.settings.${props.statsKey}`);
      }}
    >
      <div className="sb-content-container">
        <p>
          <i className={props.icontype} aria-hidden="true" />
          {props.name}
        </p>
        <p><i className="fa fa-chevron-right" aria-hidden="true" /></p>
      </div>
    </button>
    <div className="description">
      <p>{props.description}</p>
    </div>
  </div>
);

SettingsButton.propTypes = {
  icontype: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  statsKey: PropTypes.string.isRequired,
};

export default SettingsButton;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/settings/settingsbutton/main.jsx